import * as http from "@/utils/request";
import {jsonToFormData} from "@/utils";

//获取运营商列表
export function operationlist(page,params){
    return http.postJSON("/operatorController/findPage?"+jsonToFormData(page),params);
}

//运营商新增
export const insert=(params)=> {
    return http.postJSON("/operatorController/insert",params)
  }

//运营商修改
export const updatePersonal=(params)=> {
  return http.postJSON("/operatorController/updatePersonal",params)
}

//导出
export const exportExcel=(params)=> {
    return http.getExcel("/operatorController/exportExcel",params,"运营商导出")
  }

//运营城市
export  const citylist =()=>{
    return http.postForm('/operatorController/findCityName')
  }

// 运营商名字检查
export function operatorName(operatorName) {
    return http.get('/operatorController/getOperatorName',{operatorName})
  }

//单个运营商详情
export function OperatorDetail(id,operatorId) {
  return http.get('/operatorController/OperatorDetail',{id,operatorId})
}

//单个运营商详情
export function containOperatorId(sign,operatorId) {
  return http.get('/operatorController/containOperatorId',{sign,operatorId})
}

export function containAppOperatorId(sign,operatorId) {
  return http.get('/operatorController/containAppOperatorId',{sign,operatorId})
}


//获取省列表
export  const province =()=>{
  return http.get('/area/getProvList')
}

//获取市列表
export  const city =(provId)=>{
  return http.get('/area/getCityByProvId',{provId})
}


//获取区县列表
export  const county =(cityId)=>{
  return http.get('/area/getAreaByCityId',{cityId})
}



// WEBPACK FOOTER //
// ./src/services/operation.js